export default __webpack_public_path__ + "static/media/undo-arrow.0c425a30.webp";